/**
 * The Aetherfall leitmotif (original). 8 bars in F major; quoted by title, cutscene_epic,
 * final_boss (minor, then heroic) and credits. Transpose with an MML `k` prefix, e.g. 'k2 ' + MOTIF.
 */
export const MOTIF =
  'o5 c4. f8 f4 g8 a8 | g4. f8 d2 | c4. f8 a4 >c8 <b-8 | a2 r8 a8 b-8 >c8 | d4. c8 <b-4 a8 g8 | a4. g8 f4 d4 | e4. f8 g4 e4 | f2. r4 |';
export const MOTIF_CH = 'F | Gm | F | Am | Bb | Dm | C7 | F';

/** Same contour mapped into D minor. */
export const MOTIF_MIN =
  'o4 a4. >d8 d4 e8 f8 | e4. d8 <b-2 | a4. >d8 f4 a8 g8 | f2 r8 f8 g8 a8 | b-4. a8 g4 f8 e8 | f4. e8 d4 <b-4 | >c+4. d8 e4 c+4 | d2. r4 |';
export const MOTIF_MIN_CH = 'Dm | C7 | Dm | F | Gm | Bb | A | Dm';

/** Lyrical D-minor answer phrase (title B section, credits). */
export const THEME_B =
  'o5 d4. e8 f4 a4 | b-4. a8 g4 f4 | e4. f8 g4 >c4< | a2. g8 f8 | g4. a8 b-4 >d4< | >c4. <b-8 a4 f4 | e4. f8 e4 c+4 | e2. r4 |';
export const THEME_B_CH = 'Dm | Bb | C | F | Gm | Bb | A | A7';
